export const apiExceptionStatus = (error: any): number | null => {
  const status = error?.status || error?.statusCode || error?.response?.status || error?.response?.statusCode

  if (!status) return null

  const numericStatus = Number(status)

  return Number.isFinite(numericStatus) ? numericStatus : null
}

export const shouldRetryWithoutAuth = (error: any) => {
  const status = apiExceptionStatus(error)

  return !!status && status < 500 && status !== 404
}
